import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const RepaymentNavUI = ({ loan, page }) => {
  return (
    <div>
      <div className='g_flex_h g_flex_left g_flex_wrap'>
        <TabLinkUI label='Repayment V1' to={`/su/loans/${loan && loan.loanId}/repayments/v1`} active={page === 'repayment_v1'} />
        <TabLinkUI label='Repayment V2' to={`/su/loans/${loan && loan.loanId}/repayments/v2`} active={page === 'repayment_v2'} />
      </div>
      <div className='g_m_top_50' />
    </div>
  );
};

export default RepaymentNavUI;
